define(function(require) {

    var $ = require('jquery');

    // msg should contain all HTML that is to be shown to the user including links.  WARNING: Do not wrap the message in any block
    // options should be a class with a type value set to 'normal' for standard notification, 'warning' for a warning, 'error' for an error
    // Sample call SetNotification('3 Clips Deleted <a href='~/undo'>Undo</a>', {type: 'normal'});

    var timeout;

    $(function() {
        $('#closenotification').click(function() {
            closeNotification();
        });
    });

    function setNotification(msgs, options) {
        clearTimeout(timeout);
        if (!msgs) {
            closeNotification();
            return;
        }
        options = options || {};

        var menu = $('#notificationinner'),
            cls = options.type || 'normal';

        // lyleshearer 11/26/2013 - can't use $.makeArray here - changes behavior if msgs is a jQuery object with length > 1
        msgs = $.isArray(msgs) ? msgs : [msgs];

        $('#notificationinner div').detach();
        $.map(msgs, function(msg, i) {
            if (msg.msg) {
                // this is a message object with a custom class and message text/html
                menu.append($('<div />').addClass(msg.cls).append(msg.msg));
            } else if (msg.tagName || msg.length) {
                // this is either a string or HTML object, either way we do the same thing
                menu.append($('<div />').addClass(cls).append(msg));
            }
        });
        menu.slideDown(250);

        if (options.duration !== -1) {
            timeout = setTimeout(function() { closeNotification(); }, (options.duration || 5) * 1000);
        }
    }

    function closeNotification() {
        $('#notificationinner').slideUp(400);
    }

    return {
        set: setNotification,
        close: closeNotification
    };
});
